/*
 * @Author: your name
 * @Date: 2020-11-25 17:16:46
 * @LastEditTime: 2022-10-27 16:51:28
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/index.js
 */
import app from './app'

import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import { vuexPlugin } from 'utils/openreplay'
import { restoreCartAwareState } from './cartSchemaVersion'

Vue.use(Vuex)

const plugins = []

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  // 没配 `reducer`，所以整个 root state 都会落 localStorage 并跨版本保留 ——
  // 顾客手机里那份购物车可能是任意老版本写下的。`restoreCartAwareState` 在
  // `replaceState` **之前**把版本对不上的购物车整个剔掉（不是「先恢复再清」，
  // 中间那一帧顾客可能已经点了结算）。为什么必须清而不是修：见 `./cartSchemaVersion`。
  restoreState: restoreCartAwareState
})
plugins.push(vuexLocal.plugin)

const modules = {}
const localStorageModules = {}

const requireComponent = require.context(
  // The relative path of its component directory
  // 其组件目录的相对路径
  './modules',
  // Whether to query its subdirectory
  // 是否查询其子目录
  false,
  // Regular expression matching the file name of the underlying component
  // 匹配基础组件文件名的正则表达式
  /\.js$/
)

requireComponent.keys().forEach(fileName => {
  const key = fileName.split('/')[1].split('.')[0]
  const modImpl = requireComponent(fileName)
  /**
   * If this component option is exported through 'export default',
   * Then '. default' will be used first,
   * Otherwise, go back to the root of the module.
   */
  /**
   * 如果这个组件选项是通过 `export default` 导出的，
   * 那么就会优先使用 `.default`，
   * 否则回退到使用模块的根。
   */
  modules[key] = modImpl.default || modImpl
})

const requireComponentLocal = require.context(
  // The relative path of its component directory
  // 其组件目录的相对路径
  './localStorageModules',
  // Whether to query its subdirectory
  // 是否查询其子目录
  false,
  // Regular expression matching the file name of the underlying component
  // 匹配基础组件文件名的正则表达式
  /\.js$/
)

requireComponentLocal.keys().forEach(fileName => {
  const key = fileName.split('/')[1].split('.')[0]
  const modImpl = requireComponentLocal(fileName)
  /**
   * If this component option is exported through 'export default',
   * Then '. default' will be used first,
   * Otherwise, go back to the root of the module.
   */
  /**
   * 如果这个组件选项是通过 `export default` 导出的，
   * 那么就会优先使用 `.default`，
   * 否则回退到使用模块的根。
   */
  localStorageModules[key] = modImpl.default || modImpl
})

// openreplay
// vuexPlugin 为 null = tracker 没启动（多版本菜单 B6 U-B6-3：菜单预览页不录屏，utils/openreplay.js）—— 那时不挂插件
if (vuexPlugin && process.env.VUE_APP_ENV === 'production') {
  // add a name to your store, optional (will be randomly generated otherwise)
  const storeTracker = vuexPlugin('MondoMenu OpenReplay')
  plugins.push(storeTracker)
} else if (vuexPlugin && process.env.VUE_APP_ENV === 'test') {
  const storeTracker = vuexPlugin('MondoMenu OpenReplay Test')
  plugins.push(storeTracker)
}

export default new Vuex.Store({
  plugins: plugins,
  ...app,
  modules: {
    ...modules,
    ...localStorageModules
  }
})
